import Modal from '@components/v2/ui/Modal/Modal';
import LangEnum from '../../../../lang/LangEnum';
import { ClarityEvents } from '../../../../lib/clarity/types/clarityEvents.types';
import { withEvent } from '../../../../lib/clarity/utils/captureEvent.utils';
import { useTranslation } from '../../../translation/TranslationContext';
import { StatusType } from '../../order.types';
import { ChangeOrderStatusModalProps } from './changeOrderStatusModal.types';
import ChangeOrderStatusModalBody from './components/ChangeOrderStatusModalBody/ChangeOrderStatusModalBody';
import { useChangeOrderStatusModal } from './hooks/useChangeOrderStatusModal';
import {
  CHANGE_ORDER_REASON_MAX_LENGTH,
  CHANGE_ORDER_STATUS_MODAL_CONFIRM_BASED_ON_TARGET_STATUS,
  CHANGE_ORDER_STATUS_MODAL_TITLE_BASED_ON_TARGET_STATUS,
} from './utils/changeOrderStatusModal.consts';
import { getChangeOrderStatusModalConfirmButtonTestId } from './utils/changeOrderStatusModal.utils';

const ChangeOrderStatusModal = ({
  isOpen,
  onClose,
  onConfirm,
  orderParams: { code, targetStatus },
}: ChangeOrderStatusModalProps) => {
  const { translate } = useTranslation();

  const { handleOnConfirm, isLoading, reason, setReason } = useChangeOrderStatusModal({
    onConfirm,
  });

  const titleLangEnum = CHANGE_ORDER_STATUS_MODAL_TITLE_BASED_ON_TARGET_STATUS[targetStatus];
  const confirmLangEnum = CHANGE_ORDER_STATUS_MODAL_CONFIRM_BASED_ON_TARGET_STATUS[targetStatus];
  const secondaryButtonLangEnum =
    targetStatus === StatusType.CANCELED ? LangEnum.GLOBAL_GO_BACK : LangEnum.GLOBAL_CANCEL_LABEL;

  return (
    <Modal
      isOpen={isOpen}
      size="standard"
      header={{ title: translate(titleLangEnum, { code }) }}
      onClose={onClose}
      footer={{
        primaryAction: {
          isLoading,
          label: translate(confirmLangEnum),
          onClick: withEvent(ClarityEvents.CHANGE_ORDER_STATUS_IN_MODAL, handleOnConfirm),
          testId: getChangeOrderStatusModalConfirmButtonTestId(targetStatus),
        },
        secondaryAction: {
          onClick: onClose,
          label: translate(secondaryButtonLangEnum),
        },
      }}
    >
      <ChangeOrderStatusModalBody
        value={reason}
        onChange={setReason}
        targetStatus={targetStatus}
        maxLength={CHANGE_ORDER_REASON_MAX_LENGTH}
      />
    </Modal>
  );
};

export default ChangeOrderStatusModal;
